export const T = {
  en_GB: { noProductCostsAvailable: "No product costs available." },
  nb_NO: { noProductCostsAvailable: "Ingen produktkostnader tilgjengelig." },
} as const;
